// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ListSettingsForm-space1-Q30SZ {
	margin-bottom: 6px !important;
}

.ListSettingsForm-space2-Pm2mg {
	margin-bottom: 12px !important;
}

.ListSettingsForm-space3-GNNbd {
	margin-bottom: 18px !important;
}

.ListSettingsForm-space4-Rg4fm {
	margin-bottom: 24px !important;
}

.ListSettingsForm-space5-pYGR0 {
	margin-bottom: 30px !important;
}

.ListSettingsForm-space6-e7rEM {
	margin-bottom: 36px !important;
}

.ListSettingsForm-space7-xnVyq {
	margin-bottom: 42px !important;
}

.ListSettingsForm-space8-iZVbN {
	margin-bottom: 48px !important;
}

.ListSettingsForm-spaceTop1-P0JbT {
	margin-top: 6px !important;
}

.ListSettingsForm-spaceTop2-nMRDf {
	margin-top: 12px !important;
}

.ListSettingsForm-spaceTop3-iQWyE {
	margin-top: 18px !important;
}

.ListSettingsForm-spaceTop4-oX0Gy {
	margin-top: 24px !important;
}

.ListSettingsForm-spaceTop5-vUv6F {
	margin-top: 30px !important;
}

.ListSettingsForm-spaceTop6-DnqoQ {
	margin-top: 36px !important;
}

.ListSettingsForm-spaceTop7-ZBglV {
	margin-top: 42px !important;
}

.ListSettingsForm-spaceTop8-uX6v1 {
	margin-top: 48px !important;
}

.ListSettingsForm-noMargin-azIwk {
	margin: 0px !important;
}

.ListSettingsForm-padding1-n0JzW {
	padding-bottom: 6px !important;
}

.ListSettingsForm-padding2-GGfX3 {
	padding-bottom: 12px !important;
}

.ListSettingsForm-padding3-_Svo2 {
	padding-bottom: 18px !important;
}

.ListSettingsForm-padding4-ZXSDz {
	padding-bottom: 24px !important;
}

.ListSettingsForm-padding5-ECtnp {
	padding-bottom: 30px !important;
}

.ListSettingsForm-padding6-FD1TM {
	padding-bottom: 36px !important;
}

.ListSettingsForm-padding7-QFaqa {
	padding-bottom: 42px !important;
}

.ListSettingsForm-paddingTop1-TKGim {
	padding-top: 6px !important;
}

.ListSettingsForm-paddingTop2-nXPka {
	padding-top: 12px !important;
}

.ListSettingsForm-paddingTop3-M00eU {
	padding-top: 18px !important;
}

.ListSettingsForm-paddingTop4-dbDuk {
	padding-top: 24px !important;
}

.ListSettingsForm-paddingTop5-m1NMy {
	padding-top: 30px !important;
}

.ListSettingsForm-paddingTop6-JsbMJ {
	padding-top: 36px !important;
}

.ListSettingsForm-paddingTop7-kSEXN {
	padding-top: 42px !important;
}

.ListSettingsForm-noPadding-Sv9Et {
	padding: 0px !important;
}

.ListSettingsForm-spaceMarginBottom0-NqTQR {
	margin-bottom: 0;
}

.ListSettingsForm-textBold-gOTqs {
	font-weight: 500 !important;
}

.ListSettingsForm-textBolder-kCrIo {
	font-weight: 700 !important;
}

.ListSettingsForm-textNormal-mcgMi {
	font-weight: normal !important;
}

/*New Design Text Colors */

.ListSettingsForm-textDarkBlue-y_cfY {
	color: rgb(20, 39, 94) !important;
}

.ListSettingsForm-textLightBlue-igmwH {
	color: rgb(57, 87, 106) !important;
}

.ListSettingsForm-textLightSandleGreen-mgZK_ {
	color: rgb(76, 86, 41) !important;
}

.ListSettingsForm-textLightBrown-XzntV {
	color: rgb(115, 79, 33) !important;
}

.ListSettingsForm-textMediumMaroon-Ap3j9 {
	color: rgb(87, 37, 51) !important;
}

.ListSettingsForm-textBrown-pszCO {
	color: rgb(160, 47, 24) !important;
}

.ListSettingsForm-textMaroon-io7kt {
	color: rgb(155, 49, 67) !important;
}

.ListSettingsForm-textDarkBrown-T6kJT {
	color: rgb(83, 18, 16) !important;
}

.ListSettingsForm-textMediumBrown-zAV6V {
	color: rgb(142, 28, 10) !important;
}

.ListSettingsForm-textSkyBlue-BvdsQ {
	color: rgb(37, 117, 141) !important;
}

.ListSettingsForm-textGray-DLBpq {
	color: rgb(77, 65, 51) !important;
}

.ListSettingsForm-errorMessage-sVfMa {
  margin-top: 5px;
  margin-bottom: 5px;
  display: block;
  color: var(--alert-color);
  font-size: 14px;
  font-weight: normal;
  /* margin-left: 5px; */
}

/** Admin - Common - Start **/

.ListSettingsForm-userText-mV_zc {
	padding-top: 3px;
	color: var(--common-text-color);
	margin: 0px;
	font-size: 14px;
}

.ListSettingsForm-panelHeader-DiQsk {
	border-radius: 4px;
	padding: 20px 25px;
	border: 1px solid var(--primary-border);
}

.ListSettingsForm-exportSection-BV2Vn {
	background: var(--common-gray-bg-color);
	padding: 24px 15px;
	display: grid;
	grid-template-columns: 28% 15% 55%;
	-webkit-box-align: center;
	    -ms-flex-align: center;
	        align-items: center;
	grid-gap: 11px;
	border: 1px solid var(--primary-border);
	border-bottom: 0;
	border-top-left-radius: 20px;
	border-top-right-radius: 20px;
}

.ListSettingsForm-exportSectionGridSub-alPD6 {
	grid-template-columns: 50% 49% !important;
}

.ListSettingsForm-exportText-V8BrF {
	color: var(--common-text-color) !important;
	text-decoration: none !important;
	display: inline-block;
	float: right;
}

.ListSettingsForm-exportLinkImg-J0bh2 {
	background: var(--primary-white-bg);
	padding: 10px;
	margin-left: 12px;
	border-radius: 4px;
}

.ListSettingsForm-exportImg-S3C4Z {
	width: 100%;
	max-width: 16px;
	vertical-align: middle;
}

.ListSettingsForm-linkBtn-n8Rtc {
	line-height: 24px;
	display: inline-block;
	vertical-align: middle;
	margin-right: 15px;
	text-align: center;
}

.ListSettingsForm-table-J96aC {
	display: table;
}

.ListSettingsForm-tableRow-pqJO6 {
	display: table-row;
}

.ListSettingsForm-tableCell-FHxox {
	display: table-cell;
	float: none;
}

.ListSettingsForm-formGroup-P4Fji {
	margin-bottom: 6px;
}

.ListSettingsForm-marginTop0-mdZmu {
	margin-top: 0;
}

.ListSettingsForm-marginBottom20-u3u67 {
	margin-bottom: 20px;
}

/******************* Admin Banner Image Section Start ****************/

.ListSettingsForm-bannerImageBg-oYX_d {
	width: 100%;
	height: 100%;
	min-height: 179px;
	background-size: contain;
	background-repeat: no-repeat;
	background-position: 50% 50%;
	position: relative;
	border-radius: 0px;
}

.ListSettingsForm-bannerDelete-s16Wm {
	position: absolute;
	top: 5px;
	right: 20px;
}

/*******************Admin Modal Start **********************/

a,
a:hover {
	cursor: pointer;
}

.ListSettingsForm-exportLink-YHBCd {
	padding-top: 10px;
	padding-right: 10px;
}

.ListSettingsForm-seachContent-LeQ97 {
	padding-left: 0px;
	margin-bottom: 5px;
}

.ListSettingsForm-marginBottom9-JMr5C {
	margin-bottom: 9px;
}

.ListSettingsForm-spaceTop52-_rZaR {
	margin-top: 52px;
}

.ListSettingsForm-profileViewInner-RNy8N {
	padding: 10px;
	border-top: 1px solid var(--primary-border);
	word-break: break-all;
}

.ListSettingsForm-profileViewMain-nxBzQ {
	border: 1px solid var(--primary-border);
	border-radius: 0px;
	border-top: 0;
}

.ListSettingsForm-profileViewlabel-hzBbq {
	display: inline-block;
	width: 38%;
	vertical-align: middle;
}

.ListSettingsForm-profileViewMainContent-YOaZn {
	display: inline-block;
	width: 62%;
	vertical-align: middle;
}

.ListSettingsForm-reviewsFormStar-8DEno {
	font-size: 32px;
	display: -webkit-box;
	display: -ms-flexbox;
	display: flex;
	-webkit-box-align: center;
	    -ms-flex-align: center;
	        align-items: center;
	gap: 2px;
	-ms-flex-wrap: wrap;
	    flex-wrap: wrap;
}

.ListSettingsForm-reviewsFormStar-8DEno svg {
	cursor: pointer;
}

.ListSettingsForm-addLanguageText-t38X0 {
	font-size: 16px;
}

/***************** Export Section Start *********************/

@media screen and (max-width: 991px) {
	.ListSettingsForm-exportSection-BV2Vn {
		grid-template-columns: 100%;
	}

	.ListSettingsForm-spaceTop52-_rZaR {
		margin-top: 18px;
	}

	.ListSettingsForm-exportText-V8BrF {
		float: none;
		margin-top: 12px;
	}

	.ListSettingsForm-exportSectionGridSub-alPD6 {
		grid-template-columns: 100% !important;
	}
}

/***************** Export Section End *********************/

/*******************Admin Modal Start **********************/

/*******************Admin Modal End **********************/

/*********************** Profile View Section  Start***********************/

@media screen and (max-width: 767px) {
	.ListSettingsForm-profileViewlabel-hzBbq {
		width: 100%;
		margin-bottom: 6px;
		text-align: center;
	}

	.ListSettingsForm-profileViewMainContent-YOaZn {
		width: 100%;
		text-align: center;
	}

	.ListSettingsForm-panelHeader-DiQsk {
		padding: 15px 15px;
	}

}

/*********************** Profile View Section  Start***********************/

.ListSettingsForm-displayTable-gUvTD {
    display: table;
    width: 100%;
}

.ListSettingsForm-displayTableCell-Ljt18 {
    display: table-cell;
    vertical-align: middle;
}

.ListSettingsForm-displayInline-W1kUB {
    display: inline-block;
}

@media (max-width: 767px) {
    .ListSettingsForm-displayInline-W1kUB {
        vertical-align: top;
        margin-right: 10px;
    }
}`, "",{"version":3,"sources":["webpack://./src/components/helpers.css","webpack://./src/components/utils.css","webpack://./src/components/siteadmin/admin-common.css","webpack://./src/components/siteadmin/ListSettingsForm/ListSettingsForm.css"],"names":[],"mappings":"AAAA;CACC,6BAA6B;AAC9B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,0BAA0B;AAC3B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,sBAAsB;AACvB;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,+BAA+B;AAChC;;AAEA;CACC,+BAA+B;AAChC;;AAEA;CACC,+BAA+B;AAChC;;AAEA;CACC,+BAA+B;AAChC;;AAEA;CACC,+BAA+B;AAChC;;AAEA;CACC,+BAA+B;AAChC;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC,uBAAuB;AACxB;;AAEA;CACC,gBAAgB;AACjB;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA,0BAA0B;;AAE1B;CACC,iCAAiC;AAClC;;AAEA;CACC,kCAAkC;AACnC;;AAEA;CACC,iCAAiC;AAClC;;AAEA;CACC,kCAAkC;AACnC;;AAEA;CACC,iCAAiC;AAClC;;AAEA;CACC,kCAAkC;AACnC;;AAEA;CACC,kCAAkC;AACnC;;AAEA;CACC,iCAAiC;AAClC;;AAEA;CACC,kCAAkC;AACnC;;AAEA;CACC,mCAAmC;AACpC;;AAEA;CACC,iCAAiC;AAClC;;AC5LA;EACE,eAAe;EACf,kBAAkB;EAClB,cAAc;EACd,yBAAyB;EACzB,eAAe;EACf,mBAAmB;EACnB,sBAAsB;AACxB;;ACLA,6BAA6B;;AAC7B;CACC,gBAAgB;CAChB,+BAA+B;CAC/B,WAAW;CACX,eAAe;AAChB;;AAEA;CACC,kBAAkB;CAClB,kBAAkB;CAClB,uCAAuC;AACxC;;AAEA;CACC,uCAAuC;CACvC,kBAAkB;CAClB,aAAa;CACb,kCAAkC;CAClC,yBAAmB;KAAnB,sBAAmB;SAAnB,mBAAmB;CACnB,cAAc;CACd,uCAAuC;CACvC,gBAAgB;CAChB,4BAA4B;CAC5B,6BAA6B;AAC9B;;AAEA;CACC,yCAAyC;AAC1C;;AAEA;CACC,0CAA0C;CAC1C,gCAAgC;CAChC,qBAAqB;CACrB,YAAY;AACb;;AAEA;CACC,mCAAmC;CACnC,aAAa;CACb,iBAAiB;CACjB,kBAAkB;AACnB;;AAEA;CACC,WAAW;CACX,eAAe;CACf,sBAAsB;AACvB;;AAEA;CACC,iBAAiB;CACjB,qBAAqB;CACrB,sBAAsB;CACtB,kBAAkB;CAClB,kBAAkB;AACnB;;AAEA;CACC,cAAc;AACf;;AAEA;CACC,kBAAkB;AACnB;;AAEA;CACC,mBAAmB;CACnB,WAAW;AACZ;;AAEA;CACC,kBAAkB;AACnB;;AAEA;CACC,aAAa;AACd;;AAEA;CACC,mBAAmB;AACpB;;AAGA,sEAAsE;;AACtE;CACC,WAAW;CACX,YAAY;CACZ,iBAAiB;CACjB,wBAAwB;CACxB,4BAA4B;CAC5B,4BAA4B;CAC5B,kBAAkB;CAClB,kBAAkB;AACnB;;AAEA;CACC,kBAAkB;CAClB,QAAQ;CACR,WAAW;AACZ;;AAEA,4DAA4D;;AAC5D;;CAEC,eAAe;AAChB;;AAEA;CACC,iBAAiB;CACjB,mBAAmB;AACpB;;AAEA;CACC,iBAAiB;CACjB,kBAAkB;AACnB;;AAEA;CACC,kBAAkB;AACnB;;AAEA;CACC,gBAAgB;AACjB;;AAEA;CACC,aAAa;CACb,2CAA2C;CAC3C,qBAAqB;AACtB;;AAEA;CACC,uCAAuC;CACvC,kBAAkB;CAClB,aAAa;AACd;;AAEA;CACC,qBAAqB;CACrB,UAAU;CACV,sBAAsB;AACvB;;AAEA;CACC,qBAAqB;CACrB,UAAU;CACV,sBAAsB;AACvB;;AAEA;CACC,eAAe;CACf,oBAAa;CAAb,oBAAa;CAAb,aAAa;CACb,yBAAmB;KAAnB,sBAAmB;SAAnB,mBAAmB;CACnB,QAAQ;CACR,mBAAe;KAAf,eAAe;AAChB;;AAEA;CACC,eAAe;AAChB;;AAEA;CACC,eAAe;AAChB;;AAEA,6DAA6D;;AAC7D;CACC;EACC,2BAA2B;CAC5B;;CAEA;EACC,gBAAgB;CACjB;;CAEA;EACC,WAAW;EACX,gBAAgB;CACjB;;CAEA;EACC,sCAAsC;CACvC;AACD;;AAEA,2DAA2D;;AAC3D,4DAA4D;;AAE5D,0DAA0D;;AAE1D,2EAA2E;;AAG3E;CACC;EACC,WAAW;EACX,kBAAkB;EAClB,kBAAkB;CACnB;;CAEA;EACC,WAAW;EACX,kBAAkB;CACnB;;CAEA;EACC,kBAAkB;CACnB;;AAED;;AAEA,2EAA2E;;ACtN3E;IACI,cAAc;IACd,WAAW;AACf;;AAEA;IACI,mBAAmB;IACnB,sBAAsB;AAC1B;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI;QACI,mBAAmB;QACnB,kBAAkB;IACtB;AACJ","sourcesContent":[".space1 {\n\tmargin-bottom: 6px !important;\n}\n\n.space2 {\n\tmargin-bottom: 12px !important;\n}\n\n.space3 {\n\tmargin-bottom: 18px !important;\n}\n\n.space4 {\n\tmargin-bottom: 24px !important;\n}\n\n.space5 {\n\tmargin-bottom: 30px !important;\n}\n\n.space6 {\n\tmargin-bottom: 36px !important;\n}\n\n.space7 {\n\tmargin-bottom: 42px !important;\n}\n\n.space8 {\n\tmargin-bottom: 48px !important;\n}\n\n.spaceTop1 {\n\tmargin-top: 6px !important;\n}\n\n.spaceTop2 {\n\tmargin-top: 12px !important;\n}\n\n.spaceTop3 {\n\tmargin-top: 18px !important;\n}\n\n.spaceTop4 {\n\tmargin-top: 24px !important;\n}\n\n.spaceTop5 {\n\tmargin-top: 30px !important;\n}\n\n.spaceTop6 {\n\tmargin-top: 36px !important;\n}\n\n.spaceTop7 {\n\tmargin-top: 42px !important;\n}\n\n.spaceTop8 {\n\tmargin-top: 48px !important;\n}\n\n.noMargin {\n\tmargin: 0px !important;\n}\n\n.padding1 {\n\tpadding-bottom: 6px !important;\n}\n\n.padding2 {\n\tpadding-bottom: 12px !important;\n}\n\n.padding3 {\n\tpadding-bottom: 18px !important;\n}\n\n.padding4 {\n\tpadding-bottom: 24px !important;\n}\n\n.padding5 {\n\tpadding-bottom: 30px !important;\n}\n\n.padding6 {\n\tpadding-bottom: 36px !important;\n}\n\n.padding7 {\n\tpadding-bottom: 42px !important;\n}\n\n.paddingTop1 {\n\tpadding-top: 6px !important;\n}\n\n.paddingTop2 {\n\tpadding-top: 12px !important;\n}\n\n.paddingTop3 {\n\tpadding-top: 18px !important;\n}\n\n.paddingTop4 {\n\tpadding-top: 24px !important;\n}\n\n.paddingTop5 {\n\tpadding-top: 30px !important;\n}\n\n.paddingTop6 {\n\tpadding-top: 36px !important;\n}\n\n.paddingTop7 {\n\tpadding-top: 42px !important;\n}\n\n.noPadding {\n\tpadding: 0px !important;\n}\n\n.spaceMarginBottom0 {\n\tmargin-bottom: 0;\n}\n\n.textBold {\n\tfont-weight: 500 !important;\n}\n\n.textBolder {\n\tfont-weight: 700 !important;\n}\n\n.textNormal {\n\tfont-weight: normal !important;\n}\n\n/*New Design Text Colors */\n\n.textDarkBlue {\n\tcolor: rgb(20, 39, 94) !important;\n}\n\n.textLightBlue {\n\tcolor: rgb(57, 87, 106) !important;\n}\n\n.textLightSandleGreen {\n\tcolor: rgb(76, 86, 41) !important;\n}\n\n.textLightBrown {\n\tcolor: rgb(115, 79, 33) !important;\n}\n\n.textMediumMaroon {\n\tcolor: rgb(87, 37, 51) !important;\n}\n\n.textBrown {\n\tcolor: rgb(160, 47, 24) !important;\n}\n\n.textMaroon {\n\tcolor: rgb(155, 49, 67) !important;\n}\n\n.textDarkBrown {\n\tcolor: rgb(83, 18, 16) !important;\n}\n\n.textMediumBrown {\n\tcolor: rgb(142, 28, 10) !important;\n}\n\n.textSkyBlue {\n\tcolor: rgb(37, 117, 141) !important;\n}\n\n.textGray {\n\tcolor: rgb(77, 65, 51) !important;\n}",".errorMessage {\n  margin-top: 5px;\n  margin-bottom: 5px;\n  display: block;\n  color: var(--alert-color);\n  font-size: 14px;\n  font-weight: normal;\n  /* margin-left: 5px; */\n}","@import '../helpers.css';\n@import '../utils.css';\n\n/** Admin - Common - Start **/\n.userText {\n\tpadding-top: 3px;\n\tcolor: var(--common-text-color);\n\tmargin: 0px;\n\tfont-size: 14px;\n}\n\n.panelHeader {\n\tborder-radius: 4px;\n\tpadding: 20px 25px;\n\tborder: 1px solid var(--primary-border);\n}\n\n.exportSection {\n\tbackground: var(--common-gray-bg-color);\n\tpadding: 24px 15px;\n\tdisplay: grid;\n\tgrid-template-columns: 28% 15% 55%;\n\talign-items: center;\n\tgrid-gap: 11px;\n\tborder: 1px solid var(--primary-border);\n\tborder-bottom: 0;\n\tborder-top-left-radius: 20px;\n\tborder-top-right-radius: 20px;\n}\n\n.exportSectionGridSub {\n\tgrid-template-columns: 50% 49% !important;\n}\n\n.exportText {\n\tcolor: var(--common-text-color) !important;\n\ttext-decoration: none !important;\n\tdisplay: inline-block;\n\tfloat: right;\n}\n\n.exportLinkImg {\n\tbackground: var(--primary-white-bg);\n\tpadding: 10px;\n\tmargin-left: 12px;\n\tborder-radius: 4px;\n}\n\n.exportImg {\n\twidth: 100%;\n\tmax-width: 16px;\n\tvertical-align: middle;\n}\n\n.linkBtn {\n\tline-height: 24px;\n\tdisplay: inline-block;\n\tvertical-align: middle;\n\tmargin-right: 15px;\n\ttext-align: center;\n}\n\n.table {\n\tdisplay: table;\n}\n\n.tableRow {\n\tdisplay: table-row;\n}\n\n.tableCell {\n\tdisplay: table-cell;\n\tfloat: none;\n}\n\n.formGroup {\n\tmargin-bottom: 6px;\n}\n\n.marginTop0 {\n\tmargin-top: 0;\n}\n\n.marginBottom20 {\n\tmargin-bottom: 20px;\n}\n\n\n/******************* Admin Banner Image Section Start ****************/\n.bannerImageBg {\n\twidth: 100%;\n\theight: 100%;\n\tmin-height: 179px;\n\tbackground-size: contain;\n\tbackground-repeat: no-repeat;\n\tbackground-position: 50% 50%;\n\tposition: relative;\n\tborder-radius: 0px;\n}\n\n.bannerDelete {\n\tposition: absolute;\n\ttop: 5px;\n\tright: 20px;\n}\n\n/*******************Admin Modal Start **********************/\na,\na:hover {\n\tcursor: pointer;\n}\n\n.exportLink {\n\tpadding-top: 10px;\n\tpadding-right: 10px;\n}\n\n.seachContent {\n\tpadding-left: 0px;\n\tmargin-bottom: 5px;\n}\n\n.marginBottom9 {\n\tmargin-bottom: 9px;\n}\n\n.spaceTop52 {\n\tmargin-top: 52px;\n}\n\n.profileViewInner {\n\tpadding: 10px;\n\tborder-top: 1px solid var(--primary-border);\n\tword-break: break-all;\n}\n\n.profileViewMain {\n\tborder: 1px solid var(--primary-border);\n\tborder-radius: 0px;\n\tborder-top: 0;\n}\n\n.profileViewlabel {\n\tdisplay: inline-block;\n\twidth: 38%;\n\tvertical-align: middle;\n}\n\n.profileViewMainContent {\n\tdisplay: inline-block;\n\twidth: 62%;\n\tvertical-align: middle;\n}\n\n.reviewsFormStar {\n\tfont-size: 32px;\n\tdisplay: flex;\n\talign-items: center;\n\tgap: 2px;\n\tflex-wrap: wrap;\n}\n\n.reviewsFormStar svg {\n\tcursor: pointer;\n}\n\n.addLanguageText {\n\tfont-size: 16px;\n}\n\n/***************** Export Section Start *********************/\n@media screen and (max-width: 991px) {\n\t.exportSection {\n\t\tgrid-template-columns: 100%;\n\t}\n\n\t.spaceTop52 {\n\t\tmargin-top: 18px;\n\t}\n\n\t.exportText {\n\t\tfloat: none;\n\t\tmargin-top: 12px;\n\t}\n\n\t.exportSectionGridSub {\n\t\tgrid-template-columns: 100% !important;\n\t}\n}\n\n/***************** Export Section End *********************/\n/*******************Admin Modal Start **********************/\n\n/*******************Admin Modal End **********************/\n\n/*********************** Profile View Section  Start***********************/\n\n\n@media screen and (max-width: 767px) {\n\t.profileViewlabel {\n\t\twidth: 100%;\n\t\tmargin-bottom: 6px;\n\t\ttext-align: center;\n\t}\n\n\t.profileViewMainContent {\n\t\twidth: 100%;\n\t\ttext-align: center;\n\t}\n\n\t.panelHeader {\n\t\tpadding: 15px 15px;\n\t}\n\n}\n\n/*********************** Profile View Section  Start***********************/","@import '../admin-common.css';\n\n.displayTable {\n    display: table;\n    width: 100%;\n}\n\n.displayTableCell {\n    display: table-cell;\n    vertical-align: middle;\n}\n\n.displayInline {\n    display: inline-block;\n}\n\n@media (max-width: 767px) {\n    .displayInline {\n        vertical-align: top;\n        margin-right: 10px;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"space1": `ListSettingsForm-space1-Q30SZ`,
	"space2": `ListSettingsForm-space2-Pm2mg`,
	"space3": `ListSettingsForm-space3-GNNbd`,
	"space4": `ListSettingsForm-space4-Rg4fm`,
	"space5": `ListSettingsForm-space5-pYGR0`,
	"space6": `ListSettingsForm-space6-e7rEM`,
	"space7": `ListSettingsForm-space7-xnVyq`,
	"space8": `ListSettingsForm-space8-iZVbN`,
	"spaceTop1": `ListSettingsForm-spaceTop1-P0JbT`,
	"spaceTop2": `ListSettingsForm-spaceTop2-nMRDf`,
	"spaceTop3": `ListSettingsForm-spaceTop3-iQWyE`,
	"spaceTop4": `ListSettingsForm-spaceTop4-oX0Gy`,
	"spaceTop5": `ListSettingsForm-spaceTop5-vUv6F`,
	"spaceTop6": `ListSettingsForm-spaceTop6-DnqoQ`,
	"spaceTop7": `ListSettingsForm-spaceTop7-ZBglV`,
	"spaceTop8": `ListSettingsForm-spaceTop8-uX6v1`,
	"noMargin": `ListSettingsForm-noMargin-azIwk`,
	"padding1": `ListSettingsForm-padding1-n0JzW`,
	"padding2": `ListSettingsForm-padding2-GGfX3`,
	"padding3": `ListSettingsForm-padding3-_Svo2`,
	"padding4": `ListSettingsForm-padding4-ZXSDz`,
	"padding5": `ListSettingsForm-padding5-ECtnp`,
	"padding6": `ListSettingsForm-padding6-FD1TM`,
	"padding7": `ListSettingsForm-padding7-QFaqa`,
	"paddingTop1": `ListSettingsForm-paddingTop1-TKGim`,
	"paddingTop2": `ListSettingsForm-paddingTop2-nXPka`,
	"paddingTop3": `ListSettingsForm-paddingTop3-M00eU`,
	"paddingTop4": `ListSettingsForm-paddingTop4-dbDuk`,
	"paddingTop5": `ListSettingsForm-paddingTop5-m1NMy`,
	"paddingTop6": `ListSettingsForm-paddingTop6-JsbMJ`,
	"paddingTop7": `ListSettingsForm-paddingTop7-kSEXN`,
	"noPadding": `ListSettingsForm-noPadding-Sv9Et`,
	"spaceMarginBottom0": `ListSettingsForm-spaceMarginBottom0-NqTQR`,
	"textBold": `ListSettingsForm-textBold-gOTqs`,
	"textBolder": `ListSettingsForm-textBolder-kCrIo`,
	"textNormal": `ListSettingsForm-textNormal-mcgMi`,
	"textDarkBlue": `ListSettingsForm-textDarkBlue-y_cfY`,
	"textLightBlue": `ListSettingsForm-textLightBlue-igmwH`,
	"textLightSandleGreen": `ListSettingsForm-textLightSandleGreen-mgZK_`,
	"textLightBrown": `ListSettingsForm-textLightBrown-XzntV`,
	"textMediumMaroon": `ListSettingsForm-textMediumMaroon-Ap3j9`,
	"textBrown": `ListSettingsForm-textBrown-pszCO`,
	"textMaroon": `ListSettingsForm-textMaroon-io7kt`,
	"textDarkBrown": `ListSettingsForm-textDarkBrown-T6kJT`,
	"textMediumBrown": `ListSettingsForm-textMediumBrown-zAV6V`,
	"textSkyBlue": `ListSettingsForm-textSkyBlue-BvdsQ`,
	"textGray": `ListSettingsForm-textGray-DLBpq`,
	"errorMessage": `ListSettingsForm-errorMessage-sVfMa`,
	"userText": `ListSettingsForm-userText-mV_zc`,
	"panelHeader": `ListSettingsForm-panelHeader-DiQsk`,
	"exportSection": `ListSettingsForm-exportSection-BV2Vn`,
	"exportSectionGridSub": `ListSettingsForm-exportSectionGridSub-alPD6`,
	"exportText": `ListSettingsForm-exportText-V8BrF`,
	"exportLinkImg": `ListSettingsForm-exportLinkImg-J0bh2`,
	"exportImg": `ListSettingsForm-exportImg-S3C4Z`,
	"linkBtn": `ListSettingsForm-linkBtn-n8Rtc`,
	"table": `ListSettingsForm-table-J96aC`,
	"tableRow": `ListSettingsForm-tableRow-pqJO6`,
	"tableCell": `ListSettingsForm-tableCell-FHxox`,
	"formGroup": `ListSettingsForm-formGroup-P4Fji`,
	"marginTop0": `ListSettingsForm-marginTop0-mdZmu`,
	"marginBottom20": `ListSettingsForm-marginBottom20-u3u67`,
	"bannerImageBg": `ListSettingsForm-bannerImageBg-oYX_d`,
	"bannerDelete": `ListSettingsForm-bannerDelete-s16Wm`,
	"exportLink": `ListSettingsForm-exportLink-YHBCd`,
	"seachContent": `ListSettingsForm-seachContent-LeQ97`,
	"marginBottom9": `ListSettingsForm-marginBottom9-JMr5C`,
	"spaceTop52": `ListSettingsForm-spaceTop52-_rZaR`,
	"profileViewInner": `ListSettingsForm-profileViewInner-RNy8N`,
	"profileViewMain": `ListSettingsForm-profileViewMain-nxBzQ`,
	"profileViewlabel": `ListSettingsForm-profileViewlabel-hzBbq`,
	"profileViewMainContent": `ListSettingsForm-profileViewMainContent-YOaZn`,
	"reviewsFormStar": `ListSettingsForm-reviewsFormStar-8DEno`,
	"addLanguageText": `ListSettingsForm-addLanguageText-t38X0`,
	"displayTable": `ListSettingsForm-displayTable-gUvTD`,
	"displayTableCell": `ListSettingsForm-displayTableCell-Ljt18`,
	"displayInline": `ListSettingsForm-displayInline-W1kUB`
};
module.exports = ___CSS_LOADER_EXPORT___;
